import { Entity } from "src/app/core/utils/entity";

export abstract class GetFileBaseEntity extends Entity {
    constructor(
        public claimId: string,
        public file_acta: string
    ){
        super();
    }
    
    abstract getPath():string;
}